import React from "react";

// Importing bootstrap components
import { Card, } from "react-bootstrap";

// Importing holiday mutations
import { useGetUpcomingHolidayQuery } from "state/slices/holiday/holidayApiSlice";

// Importing date utilities
import { formatDate } from "utils/date";

const UpcomingHoliday = () => {
  // Fetch holidays
  const {
    data: upcomingHolidayData,
    isLoading: isUpcomingHolidaysLoading,
  } = useGetUpcomingHolidayQuery();

  return (
    <Card className="card">
      <Card.Body>
        <h5 className="card-title">
          <i className="bi-airplane me-2"></i>
          Upcoming Holiday
        </h5>
        <div className="mb-2 mt-3">
          <h6 className="fs-6 fw-medium">
            {isUpcomingHolidaysLoading
              ? "Loading..."
              : upcomingHolidayData
              ? `${upcomingHolidayData.name} ~ ${formatDate(upcomingHolidayData.date, 'dd-MM-yyyy')}`
              : "No upcoming holidays."}
          </h6>
        </div>
      </Card.Body>
    </Card>
  );
};

export default UpcomingHoliday;
